<script>
  import AppPageHeader from '../../../components/main/PageHeader'
  import EmptyList from '../../../components/list/EmptyList'

  import * as restfulService from '../../../services/restfulService'

  import bus from '@utils/bus'
  import helpers from '@mixins/helper'

  export default {
    mixins: [helpers],
    components: {AppPageHeader, EmptyList},
    data () {
      return {
        mostrarDatepickerDataInicial: false,
        mostrarDatepickerDataFinal: false,
        dataInicial: null,
        dataFinal: null,
        dataInicialFormatada: null,
        dataFinalFormatada: null,
        tipo: null,
        mostrarModalPdf: false,
        pdfBase64: '',
        dependencias: {
          tipos: [
            {
              id: 1,
              text: 'DEMONSTRATIVO PARA IMPOSTO DE RENDA'
            },
            {
              id: 2,
              text: 'DEMONSTRATIVO FINANCEIRO'
            }
          ]
        }
      }
    },
    computed: {
      habilitarGeracaoDemonstrativo: function () {
        return this.dataInicial && this.dataFinal && this.tipo
      }
    },
    watch: {
      dataInicial () {
        this.dataInicialFormatada = this.dateFormat(this.dataInicial, 'br')
      },
      dataFinal () {
        this.dataFinalFormatada = this.dateFormat(this.dataFinal, 'br')
      }
    },
    mounted () {
      this.dataInicial = this.dateFormat(this.momentNow().startOf('year'), 'en')
      this.dataFinal = this.dateFormat(this.momentNow().endOf('month'), 'en')
      bus.$emit('hide-loader')
    },
    methods: {
      imprimirPdf () {
        bus.$emit('show-loader')
        let data = {
          data_inicial: this.dataInicial,
          data_final: this.dataFinal,
          tipo: this.tipo
        }
        restfulService.post('demonstrativo', 'pdf', null, data)
          .then((response) => {
            this.pdfBase64 = 'data:application/pdf;base64,' + response.base64
            this.mostrarModalPdf = true
            bus.$emit('hide-loader')
          })
          .catch(e => {
            bus.$emit('hide-loader')
            console.log(e)
          })
      }
    }
  }
</script>

<template>
    <div class="page-content">
        <app-page-header/>
        <div class="box">
            <v-container fluid grid-list-md>
                <v-layout row wrap>
                    <v-flex sm4 xs12>
                        <v-menu ref="datepickerDataInicial"
                                :close-on-content-click="false"
                                v-model="mostrarDatepickerDataInicial"
                                :nudge-right="40"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                max-width="290px"
                                min-width="290px">
                            <v-text-field slot="activator"
                                          v-model="dataInicialFormatada"
                                          label="Data Inicial"
                                          persistent-hint
                                          prepend-icon="event"
                                          @blur="dataInicial = dateFormat(dataInicialFormatada, 'en')"/>
                            <v-date-picker v-model="dataInicial"
                                           @input="mostrarDatepickerDataInicial = false"
                                           locale="pt-br"/>
                        </v-menu>
                    </v-flex>
                    <v-flex sm4 xs12>
                        <v-menu ref="datepickerDataFinal"
                                :close-on-content-click="false"
                                v-model="mostrarDatepickerDataFinal"
                                :nudge-right="40"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                max-width="290px"
                                min-width="290px">
                            <v-text-field slot="activator"
                                          v-model="dataFinalFormatada"
                                          label="Data Final"
                                          persistent-hint
                                          prepend-icon="event"
                                          @blur="dataFinal = dateFormat(dataFinalFormatada, 'en')"/>
                            <v-date-picker v-model="dataFinal"
                                           @input="mostrarDatepickerDataFinal = false"
                                           locale="pt-br"/>
                        </v-menu>
                    </v-flex>
                    <v-flex sm4 xs12>
                        <v-select :items="dependencias.tipos"
                                  v-model="tipo"
                                  label="Tipo de Demonstrativo"
                                  item-value="id"
                                  item-text="text"
                                  single-line
                                  clearable/>
                    </v-flex>
                </v-layout>
            </v-container>
            <empty-list v-if="!habilitarGeracaoDemonstrativo"
                        title="Selecione a Data Inicial/Final e Tipo de Demonstrativo"
                        description="Para habilitar a geração do demonstrativo você precisa preencher todos os campos"/>
            <div class="text-xs-center atestados-gerar-botoes">
                <v-btn color="primary" large
                       :disabled="!habilitarGeracaoDemonstrativo"
                       @click="imprimirPdf()">
                    <i class="fas fa-print"></i>
                    <span class="pl-1">Gerar Demonstrativo</span>
                </v-btn>
            </div>
        </div>
        <v-dialog v-model="mostrarModalPdf" width="80%">
            <v-card class="modal-pdf">
                <v-card-text>
                    <iframe :src="pdfBase64"></iframe>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @click="mostrarModalPdf = false">Fechar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>



// WEBPACK FOOTER //
// Demonstrativo.vue?9ad74ba2